<template>
  <div id="app">
    <router-view :key="$route.fullPath"></router-view>
    <Create v-if="isModalVisible" @close="isModalVisible = false"></Create>
    <Explainer
      v-if="isExplainerModalVisible"
      @close="isExplainerModalVisible = false"
    ></Explainer>
  </div>
</template>
<script>
import Create from "./components/modals/Create.vue";
import Explainer from "./components/modals/Explainer.vue";

import "./assets/css/modal.css";

export default {
  name: "App",
  components: {
    Create,
    Explainer,
  },
  created() {
    this.updateprofile();
    this.csrfinit();
  },
  data() {
    return {
      auth: null,
    };
  },
  methods: {},
  computed: {
    isModalVisible: function () {
      return this.$store.state.createModal;
    },
    isExplainerModalVisible: function () {
      return this.$store.state.explainerModal;
    },
  },
};
</script>

<style>
strong {
  font-synthesis: none;
  font-weight: 700;
}

body {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 1em;
  line-height: 1.5em;
  color: #000;
  background-color:#f6f6f6;
}
a:hover {
  text-decoration: none;
}
.btn {
  border-radius: 0px;
}
</style>
